<template>
  <div>
    <backButton></backButton>
    Ticket Page
  </div>
</template>
<script>
import backButton from "../components/backButton.vue";
export default {
  components: {
    backButton,
  },
  methods: {},
};
</script>
<style lang="scss"></style>
